import { NUMBERS, ISquare } from 'typings';

interface IInput {
    square: ISquare
    value: NUMBERS
}

/**
 * A function that returns true if the value is already being used in the current grid square.
 * @param input Object with 3X# Square and value.
 */
function isInSquare({ square, value }: IInput): boolean {
    return [...square[0], ...square[1], ...square[2]].includes(value)
}

export default isInSquare
